import loadable from "@loadable/component";
import APIS from "../../constant/EndPoint";
import usePostHook from "../../customHooks/usePostHook";
import CreateIcon from "../../Icons/CreateIcon";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
const CreateReferenceTypeComponent = loadable(
  () => import("../../components/ReferenceType/CreateReferenceType")
);
const CreateReferenceType = () => {
  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["reference-type"],
    navigateURL: "/reference-type",
  });

  const handleCreate = async (values: any, setError: any) => {
    const url = `${APIS.REFERENCE_TYPE}`;
    let formData = {
      ...values,
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Create Reference Type
        </span>
      </div>
      <CreateReferenceTypeComponent
        isLoading={isPostLoading}
        handleCreate={handleCreate}
      />
    </>
  );
};

export default CreateReferenceType;
